// src/pages/Account.jsx
import React, { useState, useEffect } from 'react';
import './Account.css';

const Account = () => {
  const [userData, setUserData] = useState({
    name: "",
    email: "",
    company: "",
    role: "Usuario",
    phone: "",
    language: "Español",
    avatar: "https://randomuser.me/api/portraits/men/76.jpg"
  });
  useEffect(() => {
    // Retrieve user info from localStorage
    const storedUserInfo = localStorage.getItem('user_info');
    if (storedUserInfo) {
      try {
        const parsedUserInfo = JSON.parse(storedUserInfo);
        setUserData(prevData => ({
          ...prevData,
          ...parsedUserInfo
        }));
      } catch (error) {
        console.error('Error parsing user info from localStorage:', error);
      }
    }
    console.log(userData)
  }, []);
  const [activeTab, setActiveTab] = useState('profile');

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setUserData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // En una aplicación real, aquí enviaríamos los datos al servidor
    alert("Perfil actualizado correctamente");
  };

  return (
    <div className="account-container">
      <h1>Mi Cuenta</h1>
      
      <div className="account-tabs">
        <button 
          className={`tab-btn ${activeTab === 'profile' ? 'active' : ''}`}
          onClick={() => setActiveTab('profile')}
        >
          Perfil
        </button>
        <button 
        style={{display: 'none'}}
          className={`tab-btn ${activeTab === 'security' ? 'active' : ''}`}
          onClick={() => setActiveTab('security')}
        >
          Seguridad
        </button>
        <button 
        style={{display: 'none'}}

          className={`tab-btn ${activeTab === 'preferences' ? 'active' : ''}`}
          onClick={() => setActiveTab('preferences')}
        >
          Preferencias
        </button>
        <button 
        style={{display: 'none'}}
          className={`tab-btn ${activeTab === 'team' ? 'active' : ''}`}
          onClick={() => setActiveTab('team')}
        >
          Equipo
        </button>
      </div>
      
      <div className="tab-content">
        {activeTab === 'profile' && (
          <div className="profile-tab">
            <div className="profile-header">
             
              <div className="user-info">
                <h2>{userData.name}</h2>
                <p className="user-role">{userData.role}</p>
                <p className="user-company">{userData.company}</p>
              </div>
            </div>
            
            <form className="profile-form" onSubmit={handleSubmit}>
              <div className="form-row">
                <div className="form-group">
                  <label>Nombre Completo</label>
                  <input 
                    type="text" 
                    name="name" 
                    defaultValue={userData.name} 
                    onChange={handleInputChange} 
                  />
                </div>
                <div className="form-group">
                  <label>Email {userData.email}</label>
                  <input 
                    type="email" 
                    name="email" 
                    defaultValue={userData.email} 
                    onChange={handleInputChange} 
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Empresa</label>
                  <input 
                    type="text" 
                    name="company" 
                    defaultValue={userData.company} 
                    onChange={handleInputChange} 
                  />
                </div>
                <div className="form-group">
                  <label>Teléfono</label>
                  <input 
                    type="text" 
                    name="phone" 
                    defaultValue={userData.phone} 
                    onChange={handleInputChange} 
                  />
                </div>
              </div>
              
              <div className="form-row">
                <div className="form-group">
                  <label>Rol</label>
                  <select 
                    name="role" 
                    defaultValue={userData.role} 
                    onChange={handleInputChange}
                  >
                    <option value="Administrador">Administrador</option>
                    <option value="Gestor">Gestor</option>
                    <option value="Usuario">Usuario</option>
                  </select>
                </div>
                <div className="form-group">
                  <label>Idioma</label>
                  <select 
                    name="language" 
                    defaultValue={userData.language} 
                    onChange={handleInputChange}
                  >
                    <option value="Español">Español</option>
                    <option value="English">English</option>
                  </select>
                </div>
              </div>
              
              <div className="form-actions">
                <button type="submit" className="save-btn">Guardar Cambios</button>
                <button type="button" className="cancel-btn">Cancelar</button>
              </div>
            </form>
          </div>
        )}
        
        {activeTab === 'security' && (
          <div className="security-tab" >
            <h2>Seguridad de la Cuenta</h2>
            <div className="security-section">
              <h3>Cambiar Contraseña</h3>
              <form className="password-form">
                <div className="form-group">
                  <label>Contraseña Actual</label>
                  <input type="password" name="currentPassword" />
                </div>
                <div className="form-group">
                  <label>Nueva Contraseña</label>
                  <input type="password" name="newPassword" />
                </div>
                <div className="form-group">
                  <label>Confirmar Nueva Contraseña</label>
                  <input type="password" name="confirmPassword" />
                </div>
                <button type="submit" className="update-btn">Actualizar Contraseña</button>
              </form>
            </div>
            
            <div className="security-section">
              <h3>Autenticación de Dos Factores</h3>
              <div className="two-factor-toggle">
                <span>Activar autenticación de dos factores</span>
                <label className="switch">
                  <input type="checkbox" />
                  <span className="slider round"></span>
                </label>
              </div>
              <p className="security-note">La autenticación de dos factores añade una capa adicional de seguridad para tu cuenta.</p>
            </div>
            
            <div className="security-section">
              <h3>Sesiones Activas</h3>
              <div className="sessions-list">
                <div className="session-item">
                  <div className="session-info">
                    <h4>Chrome en Windows 10</h4>
                    <p>Madrid, España • Activo ahora</p>
                  </div>
                  <span className="current-session-badge">Actual</span>
                </div>
                <div className="session-item">
                  <div className="session-info">
                    <h4>Safari en iPhone</h4>
                    <p>Barcelona, España • Hace 2 horas</p>
                  </div>
                  <button className="logout-session-btn">Cerrar Sesión</button>
                </div>
              </div>
            </div>
          </div>
        )}
        
        {activeTab === 'preferences' && (
          <div className="preferences-tab">
            <h2>Preferencias</h2>
            <div className="preference-section">
              <h3>Notificaciones</h3>
              <div className="notification-option">
                <div>
                  <h4>Alertas de bots</h4>
                  <p>Recibe notificaciones cuando un bot necesite atención</p>
                </div>
                <label className="switch">
                  <input type="checkbox" defaultChecked />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="notification-option">
                <div>
                  <h4>Informes semanales</h4>
                  <p>Recibe un resumen semanal del rendimiento de tus bots</p>
                </div>
                <label className="switch">
                  <input type="checkbox" defaultChecked />
                  <span className="slider round"></span>
                </label>
              </div>
              <div className="notification-option">
                <div>
                  <h4>Noticias de producto</h4>
                  <p>Mantente informado sobre nuevas características y mejoras</p>
                </div>
                <label className="switch">
                  <input type="checkbox" />
                  <span className="slider round"></span>
                </label>
              </div>
            </div>
            
            <div className="preference-section">
              <h3>Apariencia</h3>
              <div className="theme-selector">
                <div className="theme-option">
                  <div className="theme-preview dark-theme"></div>
                  <span>Oscuro</span>
                  <input type="radio" name="theme" defaultChecked />
                </div>
                <div className="theme-option">
                  <div className="theme-preview light-theme"></div>
                  <span>Claro</span>
                  <input type="radio" name="theme" />
                </div>
                <div className="theme-option">
                  <div className="theme-preview system-theme"></div>
                  <span>Sistema</span>
                  <input type="radio" name="theme" />
                </div>
              </div>
            </div>
          </div>
        )}
        
        {activeTab === 'team' && (
          <div className="team-tab">
            <div className="team-header">
              <h2>Gestión de Equipo</h2>
              <button className="invite-btn">+ Invitar Usuario</button>
            </div>
            
            <div className="team-members">
              <table className="members-table">
                <thead>
                  <tr>
                    <th>Usuario</th>
                    <th>Rol</th>
                    <th>Email</th>
                    <th>Último Acceso</th>
                    <th>Acciones</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="user-cell">
                      <img src="https://randomuser.me/api/portraits/men/76.jpg" alt="Avatar" className="user-avatar" />
                      <span>Carlos Rodríguez</span>
                    </td>
                    <td>Administrador</td>
                    <td>carlos.rodriguez@empresa.com</td>
                    <td>Ahora</td>
                    <td className="actions-cell">
                      <span className="current-user-label">Tú</span>
                    </td>
                  </tr>
                  <tr>
                    <td className="user-cell">
                      <img src="https://randomuser.me/api/portraits/women/65.jpg" alt="Avatar" className="user-avatar" />
                      <span>Ana García</span>
                    </td>
                    <td>Gestor</td>
                    <td>ana.garcia@empresa.com</td>
                    <td>Hace 1 hora</td>
                    <td className="actions-cell">
                      <button className="edit-user-btn">Editar</button>
                      <button className="remove-user-btn">Eliminar</button>
                    </td>
                  </tr>
                  <tr>
                    <td className="user-cell">
                      <img src="https://randomuser.me/api/portraits/men/42.jpg" alt="Avatar" className="user-avatar" />
                      <span>Miguel López</span>
                    </td>
                    <td>Usuario</td>
                    <td>miguel.lopez@empresa.com</td>
                    <td>Hace 2 días</td>
                    <td className="actions-cell">
                      <button className="edit-user-btn">Editar</button>
                      <button className="remove-user-btn">Eliminar</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default Account;